// src/components/shared/FormattingToolbar.jsx
// The formatting toolbar for plain-text editors: Bold, Italic, Heading, Subheading. It inserts the
// markers formatTextWithStyles renders (src/utils/formatText.js — applyTextFormatting). One
// toolbar for every editor that formats text: articles (AddEditArticle) and group Introductions
// (AddEditLandingPageGroup) — group form brief 2026-10-04, addendum 2 item 2 ("no second editor").
//
// Labels are the existing article keys, read with an explicit namespace so the toolbar works under
// any caller's useTranslation.
//
// LAYOUT § Usage Rule documented exception: these are icon-only formatting controls in a compact
// segmented strip (hover tint, a divider between groups). StandardButton variant="inline" cannot
// express that markup without changing how the article editor looks, so the toolbar keeps the
// plain <button>s it had inline in AddEditArticle before it was extracted here.

import React from 'react';
import { Bold, Italic, Heading2, Heading3 } from 'lucide-react';
import { useTranslation } from '../../i18n/useTranslation';

const BUTTON_CLASS = 'p-1.5 rounded hover:bg-gray-100 transition-colors text-gray-600';

const FormattingToolbar = ({ onFormat, className = 'flex items-center gap-1 border border-gray-300 rounded-lg p-1 mr-2' }) => {
  const { t } = useTranslation('articles');
  return (
    <div className={className}>
      <button type="button" onClick={() => onFormat('bold')} title={t('articles:bold')} className={BUTTON_CLASS}>
        <Bold size={18} />
      </button>
      <button type="button" onClick={() => onFormat('italic')} title={t('articles:italic')} className={BUTTON_CLASS}>
        <Italic size={18} />
      </button>
      <div className="w-px h-5 bg-gray-300 mx-0.5" />
      <button type="button" onClick={() => onFormat('h2')} title={t('articles:heading')} className={BUTTON_CLASS}>
        <Heading2 size={18} />
      </button>
      <button type="button" onClick={() => onFormat('h3')} title={t('articles:subheading')} className={BUTTON_CLASS}>
        <Heading3 size={18} />
      </button>
    </div>
  );
};

export default FormattingToolbar;
